import { render, staticRenderFns } from "./AddreservePlan.vue?vue&type=template&id=08251df4&scoped=true"
import script from "./AddreservePlan.vue?vue&type=script&lang=js"
export * from "./AddreservePlan.vue?vue&type=script&lang=js"
import style0 from "./AddreservePlan.vue?vue&type=style&index=0&id=08251df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08251df4",
  null
  
)

export default component.exports